import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import "../styles/editProfile.css";
import { updateDetailsAction } from "../redux/slices/userSlices";

const updateDetailsForm = Yup.object({
  name: Yup.string().required("Team name is required"),
  collegeName: Yup.string().required("college name is required"),
  profilePic: Yup.string().required("profile picture is required"),
});

const EditProfile = () => {
  const dispatch = useDispatch();

  const UserstoreData = useSelector((store) => store?.users);
  const { user } = UserstoreData;

  const [profilePhoto, setProfilePhoto] = useState(user?.profilePic);
  const [showAvatarOptions, setShowAvatarOptions] = useState(false);

  const avatars = [
    "https://img.freepik.com/premium-vector/cute-boy-smiling-cartoon-kawaii-boy-illustration-boy-avatar-happy-kid_1001605-3445.jpg",
    "https://i.pinimg.com/originals/c0/4b/01/c04b017b6b9d1c189e15e6559aeb3ca8.png",
    "https://img.freepik.com/premium-photo/cute-girl-3d-character-design-cartoon-girl-avatar_432516-5511.jpg",
    "https://img.freepik.com/premium-photo/teacher-woman-avatar-icon-illustration-vector-style_131965-973.jpg",
  ];

  const handleAvatarChange = (avatar) => {
    setProfilePhoto(avatar);
    setShowAvatarOptions(false); // Hide avatar options after selecting
  };

  const detailsformik = useFormik({
    initialValues: {
      name: user?.name,
      collegeName: user?.college,
      profilePic: user?.profilePic,
    },

    onSubmit: (values) => {
      values.profilePic = profilePhoto;
      dispatch(updateDetailsAction(values));
    },
    validationSchema: updateDetailsForm,
  });

  return (
    <div className="profile-container">
      <h2>Edit Profile</h2>
      <div className="profile-box">
      
        <div className="left-side">
          <div className="photo-container">
            <img
              src={profilePhoto}
              alt="ProfilePhoto"
              className="profile-photo"
            />
            <button
              type="button"
              
              className="change-photo-btn"
              onClick={() => setShowAvatarOptions(!showAvatarOptions)}
            >
              Change Photo
            </button>
          </div>

          {showAvatarOptions && (
            <div className="avatar-options-panel">
              <div className="avatar-options-header">
                <h3>Select Avatar</h3>
                <button
                  className="close-btn"
                  type="button"
                  onClick={() => setShowAvatarOptions(false)}
                >
                  X
                </button>
              </div>
              <div className="avatar-options-body">
                {avatars.map((avatar, index) => (
                  <img
                    key={index}
                    src={avatar}
                    alt={`Avatar ${index + 1}`}
                    className="avatar-option"
                    onClick={() => handleAvatarChange(avatar)}
                  />
                ))}
              </div>
            </div>
          )}
        </div>

        <form className="editProfileForm" onSubmit={detailsformik.handleSubmit}>
          <div className="right-side">
           
            <div className="input-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                value={detailsformik.values.name}
                onChange={detailsformik.handleChange("name")}
                placeholder="Enter your name"
                style={{ borderRadius: "10px" }}
              />
              <label htmlFor="college">College Name</label>
              <input
                type="text"
                id="college"
                value={detailsformik.values.collegeName}
                onChange={detailsformik.handleChange("collegeName")}
                placeholder="Enter college name"
                style={{ borderRadius: "10px" }}
              />
            </div>
            <div className="buttons">
              <button className="save-btn" style={{ borderRadius: "10px" }}>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProfile;
